<template>
  <div class="bg">
    <top-nav title="联系我们"></top-nav>
    <div class="cec-info">
			<img class="absolute-img" src="@/assets/images/cec2022/bird.png"/>
			<img src="@/assets/images/cec2022/contact_title1.png" />
			<div class="text" style="margin-left: 10px;">
                <span class="bolder">王小雪</span><br />
				<p class="line1" style="margin-bottom:10px"><img src="@/assets/images/cec2022/mobile_icon.png"/><span>18301500643</span></p>
                <span class="bolder">王蕴</span><br />
				<p class="line1"><img src="@/assets/images/cec2022/mobile_icon.png"/><span>13501361743</span></p>
				<p class="line1" style="margin-bottom:10px"><img src="@/assets/images/cec2022/email_icon.png"/><span>great_harbour@163.com</span></p>
                <span class="bolder">李雪梅</span><br />
				<p class="line1"><img src="@/assets/images/cec2022/mobile_icon.png"/><span>15711037590（交通住宿）</span></p>
				<p class="line1"><img src="@/assets/images/cec2022/email_icon.png"/><span>yun.wang@cec-conference.com</span></p>
			</div>
			<img src="@/assets/images/cec2022/contact_title2.png" />
			<div class="text"  style="margin-left: 10px;">
				<span class="bolder">岳嘉宁</span><br />
				<p class="line1"><img src="@/assets/images/cec2022/mobile_icon.png"/><span>13564788422</span></p>
				<p class="line1"><img src="@/assets/images/cec2022/email_icon.png"/><span>yuejianing@gmail.com</span></p>
			</div>
			<img src="@/assets/images/cec2022/contact_title3.png" />
			<div class="text"  style="margin-left: 10px;">
				<span class="bolder">刘辉</span><br />
				<p class="line1"><img src="@/assets/images/cec2022/mobile_icon.png"/><span>18616004800 </span></p>
				<p class="line1" style="margin-bottom:10px"><img src="@/assets/images/cec2022/email_icon.png"/><span>shane.liu@edoctor.cn</span></p>
				<span class="bolder">王林盈</span><br />
				<p class="line1"><img src="@/assets/images/cec2022/mobile_icon.png"/><span>18516290250</span></p>
				<p class="line1"><img src="@/assets/images/cec2022/email_icon.png"/><span>vascularnews@163.com</span></p>
			</div>
		</div>
		<img src="@/assets/images/cec2022/bottom_img.png" class="bottom-img"/>
  </div>
</template>

<script>
import topNav from "./component/topNav.vue" 
import {ButtonDetail} from '../../config/interface.js'

export default {
    components:{
        topNav
    },
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.getButtonData();
    },
    methods:{
            //获取按钮信息
			getButtonData(){
				if(this.button_id){
					const url=ButtonDetail;
					let params={
                    	button_id:this.button_id
					}
					const method="POST";
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							document.title=res.data.share_title;
							if(common.is_weixin()){
								let data=res.data;
								common.wxShare(data.share_title,data.share_sub_title,data.share_img);
							}
						}
					})

				}
			}
    }
}
</script>

<style scoped>
.bg{
    background: white;
    margin-top: 48px;
}
.cec-info{
	padding: 30px 25px;
	position: relative;
}
.cec-info img{
	width: 100%;
}
.cec-info .absolute-img{
	position: absolute;
	top:30px;
	left: 0;
}
.cec-info .red-text{
	color: #B2312E;
}
.cec-info .text{
	margin: 10px 0 30px;
	font-size: 0.31rem;
	line-height: 26px;
}
.cec-info .line1{
	line-height: 32px;
}
.cec-info .line1 img{
	width: 20px;
	vertical-align: middle;
	line-height: 32px;
	margin-right: 5px;
}
.bolder{
    font-weight: 500;
}
.bottom-img{
    width: 100%;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/pages/cec2022/contact.vue